import { Alert, Box, Typography } from '@mui/material';

import ProductIncomeForm from './ProductIncomeForm';

const ProductIncome = () => {
  return (
    <Box mt={2}>
      <Typography fontWeight={800}>
        โครงสร้างรายได้ของสายผลิตภัณฑ์หรือกลุ่มธุรกิจ
      </Typography>
      <Alert severity="info" sx={{ mt: 2 }}>
        คำชี้แจง:
        กรุณาระบุรายได้ของสายผลิตภัณฑ์หรือกลุ่มธุรกิจอย่างน้อยหนึ่งรายการ
        ทั้งนี้ บริษัทไม่จำเป็นต้องระบุ
        รายได้จากส่วนแบ่งกำไรจากเงินลงทุนในบริษัทร่วม
      </Alert>
      <ProductIncomeForm />
    </Box>
  );
};

export default ProductIncome;
